/* ponytail: minimal replacement for the missing jquery.cookie plugin.
   theme.js calls $.cookie(name) / $.cookie(name, value, {expires, path}) in a
   few places (announcement bar, tab memory); the plugin file was never
   bundled with this theme, so those calls threw "e.cookie is not a
   function" and aborted halo.ready() before it reached menuSidebarMobile(),
   which is why the mobile hamburger button did nothing. */
(function ($) {
    if (!$ || $.cookie) return;
    $.cookie = function (name, value, options) {
        if (typeof value === 'undefined') {
            var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + '=([^;]*)'));
            return match ? decodeURIComponent(match[1]) : null;
        }
        options = options || {};
        var expires = '';
        if (options.expires) {
            var date = new Date();
            date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=' + (options.path || '/');
    };
})(window.jQuery);
